<template>
  <a-modal
    :title="title"
    :width="getWidth()"
    :visible="visible"
    :confirmLoading="loading"
    @ok="() => { $emit('ok', turningMonthList) }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="24" v-if="model['type'] === 1">
            <a-form-item label="固定价">
              <a-input-number style="width: 100%" allow-clear v-decorator="['fixed_price', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="model['type'] === 2">
            <a-form-item label="期货合约">
              <a-date-picker
                v-decorator="['futures_contract', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                show-time
                format="YYYY-MM-DD"
                placeholder="期货合约"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
            <a-form-item label="锁价期限">
              <a-date-picker
                v-decorator="['lock_up_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                show-time
                format="YYYY-MM-DD"
                placeholder="锁价期限"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
            <a-form-item label="默认计价期">
              <a-range-picker
                @change="time"
                format="YYYY-MM-DD"
                style="width: 100%"
                v-decorator="['pricing_period', {rules: [{required: true, message: '必填项，请填写信息'}]}]">
                <template slot="dateRender" slot-scope="current">
                  <div class="ant-calendar-date" :style="getCurrentStyle(current)">
                    {{ current.date() }}
                  </div>
                </template>
              </a-range-picker>
            </a-form-item>
            <a-form-item label="升贴水">
              <a-input-number allow-clear v-decorator="['premium_discount', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]"/>
              <span style="padding-left: 10px">正数为升水、负数为贴水</span>
            </a-form-item>
            <a-form-item label="点价费">
              <a-input-number allow-clear v-decorator="['price_fixing_fee', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]"/>
            </a-form-item>
            <a-form-item label="转月费">
              <a-input-number allow-clear v-decorator="['monthly_transfer_fee', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]"/>
            </a-form-item>
            <a-form-item label="是否可转月">
              <a-switch checked-children="是" un-checked-children="否" @change="addTurningMonth" />
              <a-table
                v-if="turningMonthList.length > 0"
                bordered
                :data-source="turningMonthList"
                ref="turningMonthTable"
                :columns="turningMonthColumns"
                :pagination="false">
                <span slot="serial" slot-scope="text, record, index">
                  {{ index + 1 }}
                </span>
                <template slot="action" slot-scope="text, record">
                  <a-popconfirm
                    title="确定删除吗?"
                    @confirm="() => onDeleteItem(record.key)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
                <template slot="footer">
                  <div style="text-align: center">
                    <a-button @click="addTurningMonth(true)" icon="plus">转月</a-button>
                  </div>
                </template>
              </a-table>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="model['type'] === 3">
            <a-form-item label="浮动参考依据">
              <a-input v-decorator="['floating_reference_basis', {rules: [{required: true, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="浮动参考依据"/>
            </a-form-item>
            <a-form-item label="价格参考期限">
              <a-range-picker
                @change="time"
                format="YYYY-MM-DD"
                style="width: 100%"
                v-decorator="['price_reference_period', {rules: [{required: true, message: '必填项，请填写信息'}]}]">
                <template slot="dateRender" slot-scope="current">
                  <div class="ant-calendar-date" :style="getCurrentStyle(current)">
                    {{ current.date() }}
                  </div>
                </template>
              </a-range-picker>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <turning-month-form
        :visible="turningMonthVisible"
        v-if="turningMonthVisible"
        :loading="false"
        @ok="turningMonthOk"
        @cancel="turningMonthCancel"
        ref="turningMonthForm"
        :size="turningMonthList.length"/>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import TurningMonthForm from './TurningMonthForm'
// 表单字段
const fields = ['fixed_price']
export default {
  components: {
    TurningMonthForm
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    }
    return {
      param: {},
      title: '单价',
      turningMonthVisible: false,
      turningMonthList: [],
      turningMonthColumns: [
        {
          title: '序号',
          width: 80,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '转月后期货合约',
          dataIndex: 'futures_contract',
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          title: '转月后默认计价期',
          dataIndex: 'pricing_period',
          ellipsis: true,
          align: 'center',
          customRender: (obj) => obj.start_date + '~' + obj.end_date
        },
        {
          title: '转月后锁价期限',
          dataIndex: 'lock_up_date',
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          width: 100,
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      form: this.$form.createForm(this)
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.$watch('model', () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
  },
  methods: {
    getWidth () {
      if (this.model['type'] === 1) {
        this.title = '固定价'
        return 480
      } else if (this.model['type'] === 2) {
        this.title = '点价'
        return 1080
      } else if (this.model['type'] === 3) {
        this.title = '浮动价格'
        return 680
      }
    },
    time (dates, dateStrings) {
      console.log(dateStrings, '时间')
      this.param.start_date = dateStrings[0]
      this.param.end_date = dateStrings[1]
    },
    getCurrentStyle (current, today) {
      const style = {}
      if (current.date() === 1) {
        style.border = '1px solid #1890ff'
        style.borderRadius = '50%'
      }
      return style
    },
    addTurningMonth (v) {
      console.log(v)
      if (!v) {
        this.turningMonthList = []
      }
      this.turningMonthVisible = v
    },
    onDeleteItem (key) {
      const dataSource = [...this.turningMonthList]
      this.turningMonthList = dataSource.filter(item => item.key !== key)
    },
    turningMonthOk (pricing_period) {
      const form = this.$refs.turningMonthForm.form
      form.validateFields((errors, values) => {
        if (!errors) {
          // 新增
          console.log('------------>>>>', values)
          this.turningMonthVisible = false
          values.pricing_period = pricing_period
          values.key = Date.now()
          this.turningMonthList.push(values)
          form.resetFields()
        }
        console.log(this.turningMonthList)
      })
    },
    turningMonthCancel () {
      this.turningMonthVisible = false
      const form = this.$refs.turningMonthForm.form
      form.resetFields()
    }
  }
}
</script>
